import { NextPage } from 'next';

import { ForgotPassword } from '~/modules/auth/pages/ForgotPassword';

import { withSSRGuest } from '~/shared/utils/withSSRGuest';

export const getServerSideProps = withSSRGuest(async () => {
  return {
    props: {},
  };
});

const ForgotPasswordPage: NextPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
